import React from 'react'
import { Header } from './marketing/Header'
import Image from 'next/image'
import { Blog, Label, Marketing } from '../designsystem/Text'

export function BlogLayout({ meta, ...props }) {
  return (
    <div className='pb-24 bg-gray-50'>
      {' '}
      <Header />
      <div className='max-w-5xl px-6 mx-auto mt-12 sm:mt-24'>
        <div className='max-w-xl mx-auto'>
          <div className='flex items-center'>
            <div className='whitespace-nowrap'>
              {meta.avatars.map((a, i) => (
                <div className='inline-block -mr-3'>
                  <a
                    href={`https://twitter.com/${meta.twitters[i]}`}
                    target='_blank'
                    rel='noopener noreferrer'
                  >
                    <img
                      src={a}
                      width='40px'
                      height='40px'
                      className='box-content relative rounded-full border-3 border-gray-50'
                      style={{
                        zIndex: 5 - i,
                        margin: 0,
                      }}
                    />
                  </a>
                </div>
              ))}
            </div>
            <Label className='ml-10 text-bg-blue'>
              {meta.authors.map((a, i) => (
                <>
                  {i > 0 && <span>{', '}</span>}
                  <a
                    href={`https://twitter.com/${meta.twitters[i]}`}
                    target='_blank'
                    rel='noopener noreferrer'
                    className='inline-block'
                  >
                    {a}
                  </a>
                </>
              ))}
            </Label>
            <Label className='ml-4 text-right opacity-50 sm:ml-12 text-gray'>
              {formatDate(meta.date)}
            </Label>
          </div>
        </div>
        <Blog.H1>{meta.title}</Blog.H1>
        <div className='relative overflow-hidden sm:-mx-18 rounded-xl shadow-small'>
          <Image
            src={meta.hero}
            layout='responsive'
            width={1312}
            height={786}
          />
        </div>
        <main
          className='max-w-xl mx-auto mt-10 prose sm:mt-24'
          style={{ color: '#3B4C6A' }}
          {...props}
        />
      </div>
    </div>
  )
}

function formatDate(date: Date): string {
  date = new Date(date)
  const month = date.toLocaleString('default', {
    month: 'long',
  })

  return `${month} ${date.getDate()}, ${date.getFullYear()}`
}
